import {
    CheckoutChargeStatusType,
    formatDate,
    renderAmount,
    SupportCheckoutCharge,
    SupportCreditCard,
} from '@enter/core';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { RootStore } from 'stores';
import * as S from './billing-timeline-table.styles';

interface ICheckoutChargeDetailProps {
    checkoutCharge: SupportCheckoutCharge;
    creditCards?: SupportCreditCard[];
}

export const CheckoutChargeDetail: React.FunctionComponent<ICheckoutChargeDetailProps> = inject('rootStore')(
    observer(
        (props: ICheckoutChargeDetailProps): React.ReactElement => {
            const rootStore: RootStore = _.get(props, 'rootStore');
            if (!rootStore) {
                return <></>;
            }
            const { claimStore } = rootStore;
            const { checkoutCharge, creditCards } = props;
            const { chargeDate, id, amount, feeAmount, creditCardId, status, refund } = checkoutCharge;

            const creditCard = _.find(creditCards, { id: creditCardId });
            const refundCharge = (charge: SupportCheckoutCharge): (() => Promise<void>) => {
                return async (): Promise<void> => {
                    await claimStore.refundCheckoutCharge(charge, {
                        refundAmount: charge.amount,
                        refundDate: new Date().toISOString(),
                        memo: 'Refund reason'
                    });
                };
            };

            return (
                <S.Table key={id} expand={true}>
                    <S.TBody>
                        <S.TR>
                            <S.TH>Date</S.TH>
                            <S.TD colSpan={2}>{formatDate(chargeDate, 'MMM d, yyyy')}</S.TD>
                        </S.TR>
                        <S.TR>
                            <S.TH>Status</S.TH>
                            <S.TD colSpan={2}>{status}</S.TD>
                        </S.TR>
                        <S.TR>
                            <S.TH>Amount</S.TH>
                            <S.TD colSpan={2}>{renderAmount(amount)}</S.TD>
                        </S.TR>
                        <S.TR>
                            <S.TH>Fee Amount</S.TH>
                            <S.TD colSpan={2}>{renderAmount(feeAmount)}</S.TD>
                        </S.TR>
                        <S.TR>
                            <S.TH>Credit Card</S.TH>
                            <S.TD colSpan={2}>
                                {creditCard?.brand} ...{creditCard?.last4Digits} {creditCard?.expirationMonth}/
                                {creditCard?.expirationYear}
                            </S.TD>
                        </S.TR>
                        {refund && status === CheckoutChargeStatusType.SUCCEEDED && (
                            <S.TR>
                                <S.TH />
                                <S.TD colSpan={2}>
                                    <S.StyledButton variant="text" onClick={refundCharge(checkoutCharge)}>
                                        Refund
                                    </S.StyledButton>
                                </S.TD>
                            </S.TR>
                        )}
                    </S.TBody>
                </S.Table>
            );
        },
    ),
);
